import type { ChatProfile } from '@customTypes/chat';
import { Avatar, Box, Flex, Indicator, Title } from '@mantine/core';

import { resolveImagePath } from '@/shared/helper';

export const ChatHeader = ({ profile }: { profile: ChatProfile }) => (
  <Box bg='white' px={20} py={16} style={{ borderRadius: '8px' }} w='100%'>
    <Flex align='center' gap={10}>
      <Indicator color='green' offset={6} position='bottom-end'>
        <Avatar size='md' src={resolveImagePath(profile.avatarUrl)} />
      </Indicator>
      <Title order={4}>{profile.displayName}</Title>
    </Flex>
  </Box>
);
